var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 11.6666V13.3333C7.23727 13.3333 4.9987 15.5718 4.9987 18.3333H3.33203C3.33203 14.6513 6.3168 11.6666 9.9987 11.6666ZM9.9987 10.8333C7.2362 10.8333 4.9987 8.59575 4.9987 5.83325C4.9987 3.07075 7.2362 0.833252 9.9987 0.833252C12.7612 0.833252 14.9987 3.07075 14.9987 5.83325C14.9987 8.59575 12.7612 10.8333 9.9987 10.8333ZM9.9987 9.16659C11.8404 9.16659 13.332 7.67492 13.332 5.83325C13.332 3.99159 11.8404 2.49992 9.9987 2.49992C8.15703 2.49992 6.66536 3.99159 6.66536 5.83325C6.66536 7.67492 8.15703 9.16659 9.9987 9.16659ZM14.9987 17.9166L12.5496 19.2042L13.0174 16.477L11.0359 14.5457L13.7741 14.1478L14.9987 11.6666L16.2233 14.1478L18.9614 14.5457L16.98 16.477L17.4478 19.2042L14.9987 17.9166Z",
    fill: "#037BC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserStar);
export default __webpack_public_path__ + "static/media/userStar.648b68d0aa173fa03fce73d9e33c0451.svg";
export { ForwardRef as ReactComponent };